<template>
    <v-card>
        <v-card-text class="py-1">
            <v-row>
                <v-col cols="11" class="py-0" >
                    <span
                            v-show="!edit"
                            class="text-caption"
                            @dblclick="edit = true"
                            title="Кликни два раза для редактирования"
                            v-html="textToHMTLFormat(cardComment.description)"
                    ></span>
                    <v-textarea
                            v-show="edit"
                            label="Редактирование комментария"
                            hide-details
                            rows="1"
                            auto-grow
                            v-model="descriptionTemp"
                    /><br>
                    <span title="Создан"> {{getDateOutUnixTime(cardComment.created_at)}}</span>
                </v-col>
                <v-col cols="1" class="px-0 py-0" v-show="edit">
                    <v-btn x-small icon class="success" dark @click="saveCardComment"
                           title="Сохранить изменения"
                    ><v-icon small>check</v-icon></v-btn>
                    <v-btn x-small icon class="info" dark @click="cancelEdit"
                        title="Отменить изменения"
                    ><v-icon small>undo</v-icon></v-btn>
                    <v-btn x-small icon class="error" dark @click="cancelEdit"
                        title="Удалить комментарий"
                    ><v-icon small>delete</v-icon></v-btn>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import timeHelpers from '../../../scripts/helpers/timeHelpers'
import textHelpers from '../../../scripts/helpers/textHelpers'
export default {
    name: 'CardCommentCard',
    props: ['cardComment'],
    data() {
        return {
            edit: false,
            descriptionTemp: ''
        }
    },
    methods: {
        saveCardComment() {
            let newCardComment = Object.assign({}, this.cardComment)
            newCardComment.description = this.descriptionTemp
            this.$store.dispatch('cards/cardCommentCreate', newCardComment).then(() => {
                this.edit = false
            })
        },
        cancelEdit() {
            this.edit = false
            this.descriptionTemp = this.cardComment.description
        },
        ...timeHelpers,
        ...textHelpers
    },
    created() {
        this.descriptionTemp = this.cardComment.description
    }
}
</script>

<style scoped>

</style>
